import React, { useRef } from 'react';
import ResourcesMainSection from '../../components/landingPage/ResourcesPage/ResourcesMainSection';
import ResourcesVideoSection from '../../components/landingPage/ResourcesPage/ResourcesVideoSection';
import ResourcesFaqSection from '../../components/landingPage/ResourcesPage/ResourcesFaqSection';
import ResourcesCtaSection from '../../components/landingPage/ResourcesPage/ResourcesCtaSection';
import { useReveal, useCountUp } from '../../components/landingPage/common/landingHooks';

const BlogPage = () => {
    const rootRef = useRef(null);
    useReveal(rootRef);
    useCountUp(rootRef);

    return (
        <div className="lp-page" ref={rootRef}>
            <ResourcesMainSection />
            <ResourcesVideoSection />
            <ResourcesFaqSection />
            <ResourcesCtaSection />
        </div>
    );
};

export default BlogPage;
